import { safeLocalStorage } from '@/services/safeLocalStorage'

const STORAGE_KEY = 'nopressure:latestVisitedOrganization'

export const latestVisitedOrganization = {
  save(organizationId: string): void {
    safeLocalStorage.set(STORAGE_KEY, organizationId)
  },

  get(): string | null {
    return safeLocalStorage.get(STORAGE_KEY)
  },

  clear(): void {
    safeLocalStorage.remove(STORAGE_KEY)
  },
}
